<div class="
    min-h-screen w-full bg-zinc-950 text-gray-100
    pt-20 pb-4
    overflow-x-hidden
    ">

    <main class="
        max-w-6xl
        mx-auto px-4 space-y-6
        ">
        <router-outlet></router-outlet>
    </main>

</div>

<nav class="
    fixed top-0 left-0 right-0
    flex flex-row
    items-center

    px-4 py-3

    bg-zinc-900

    shadow-md shadow-black/40
    h-16
    ">

    <img src="https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/home/nav-bar-logo-01.png"
        alt="{{ 'app.nav.noLogoTitle' | translate }}" class="h-8 mr-2" (error)="onLogoError($event)">

    <span class="text-lg font-bold text-white" *ngIf="logoError">{{ 'app.nav.noLogoTitle' | translate }}</span>

    <div class="
        flex flex-row gap-2
        items-center justify-center align-middle

        ml-auto
        bg-cyan-500/0
        text-gray-300
        ">

        <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-5 h-5 text-gray-400 bg-pink-500/0">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 3c2.755 2.806 4.277 6.19 4.5 9-.223 2.81-1.745 6.194-4.5 9-2.755-2.806-4.277-6.19-4.5-9 .223-2.81 1.745-6.194 4.5-9z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.6 9h16.8M3.6 15h16.8" />
        </svg>

        <label for="langSelect" class="mr-1 bg-pink-500/0">
            {{ 'ui.language' | translate }}
        </label> -->

        <select id="langSelect" (change)="onLanguageChange($event)" [value]="translate.getCurrentLang()" class="
                hidden sm:block
                px-3 py-2

                bg-zinc-800

                text-gray-100
                rounded border border-zinc-700
                focus:outline-none
                ">

            <option value="en">{{ 'language.en' | translate }}</option>
            <option value="pt">{{ 'language.pt' | translate }}</option>
            <option value="es">{{ 'language.es' | translate }}</option>

        </select>

        <select id="langSelect" (change)="onLanguageChange($event)" [value]="translate.getCurrentLang()" class="
                block sm:hidden
                px-3 py-2

                bg-zinc-800

                text-gray-100
                rounded border border-zinc-700
                focus:outline-none
                ">

            <option class="text-center" value="en">en-us</option>
            <option class="text-center" value="pt">pt-br</option>
            <option class="text-center" value="es">es</option>

        </select>

    </div>
</nav>

<app-version-panel></app-version-panel>